import { buildUri } from '../../endpoints';

/**
 * A general utility class for Rise courses.
 */
export class ScormRiseUtils {

    /**
     * Returns the entry path for the course. This is the path used to open the course.
     * 
     * @param { object } path - The initial path to access the course.
     * @param { object } options - Additional data to store in the built path to change course behaviors.
     * @returns { string }
     */
    static buildEntryPath( path, { localeCode } = {} ) {
        if ( path && typeof path == 'string' ) {
            // Build the entry path for the Rise course using some possible query string params.
            // Not sure if the language param is actually being used in Rise courses right now...
            return buildUri( path, {}, { language: localeCode } );
        }
        else {
            return undefined;
        }
    }

    /**
     * Returns whether or not the provided entry path to the course is recognized as a
     * Rise entry path.
     * 
     * @param { string } path - The path to access the entry point to the file. Used to open and launch the course.
     * @returns { boolean }
     */
    static isValidEntryPath( path ) {
        return ( path?.indexOf( 'indexAPI.html' ) >= 0 );
    }

}
